var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHhand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 87,
    viewBox: "0 0 79 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6689 23.9824C43.543 24.4322 46.8799 24.5447 48.0045 24.5447C49.1291 24.5447 51.041 24.6571 53.6276 24.5447C56.2142 24.4322 57.1139 23.0827 57.3388 20.0462C57.3388 20.0462 57.4513 17.3472 55.0896 17.0665C52.7279 16.7858 43.5628 17.0665 43.5628 17.0665C43.5628 17.0665 42.9438 17.098 42.269 16.9414",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6334 10.0409C71.6334 10.0409 74.0941 8.80021 73.045 6.40075C71.996 4.00129 67.7971 3.70169 65.7729 3.1016C63.7486 2.50151 56.6257 0.927055 53.6271 1.00263C50.6284 1.0773 47.1043 2.35216 42.9811 3.62702C42.9811 3.62702 41.4813 4.15153 40.3567 4.37645C39.2321 4.60138 36.8326 5.35082 36.4584 8.35037C36.0841 11.3499 34.8839 11.5155 34.1345 12.1443C33.385 12.7732 32.4098 14.165 33.4597 16.9181C34.5096 19.6711 34.5843 19.6711 34.3594 22.0697C34.1345 24.4683 36.2334 24.6941 37.1331 28.5924C37.1331 28.5924 37.8826 32.9217 39.1196 36.4089C39.1196 36.4089 39.9069 38.1525 40.0193 39.5578C40.1318 40.9631 40.0193 41.9195 40.3 43.1008C40.5807 44.2821 41.0144 44.794 41.3688 45.6874C42.0922 47.5137 42.7184 49.9609 42.8479 50.6356C42.9775 51.3104 42.9811 59.3329 42.9811 59.3329C42.6815 66.5304 42.9811 76.2767 42.9811 76.2767",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6289 31.5927C47.6289 31.5927 48.8543 32.8676 53.1521 31.9679C57.4499 31.0682 57.8251 28.9692 57.9753 27.5441C58.1256 26.1199 57.987 24.4402 54.5367 24.4402",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4026 32.2891C50.4026 32.2891 49.8781 34.2918 46.4287 35.6413",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2504 16.5598C59.2504 16.5598 59.909 23.6008 57.9756 27.5432",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4946 30.5742C56.4946 30.5742 56.3822 30.7892 55.5382 33.9642C54.6943 37.1392 55.1442 40.0641 55.1442 43.213C55.1442 46.3619 56.6062 54.0093 57.6183 58.0579C58.6305 62.1064 61.1613 72.7902 62.6224 75.7142C64.0835 78.6382 64.9274 80.9999 64.9274 80.9999",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4025 16.9421C50.4025 16.9421 55.3507 16.8971 56.9252 16.5598C58.4996 16.2224 65.2473 16.522 67.1969 16.5598C69.1465 16.5975 75.2941 16.8225 76.7939 15.248C78.2936 13.6736 77.7682 10.8243 75.5946 10.6749C73.42 10.5247 69.2221 9.84989 68.1722 9.84989C67.1222 9.84989 63.2977 9.50261 60.5437 9.08156C58.8208 8.81795 55.8761 8.06941 54.021 7.90117C52.1658 7.73293 51.3075 8.40499 49.5109 8.68839C46.8325 9.11035 47.5594 9.14184 45.3048 9.30648C43.7223 9.42254 42.7578 9.37755 42.7578 9.37755",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.543 74H30.6836V61.8125H19.2578V74H13.3984V45.5625H19.2578V57.0859H30.6836V45.5625H36.543V74Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 62.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHhand);
export default __webpack_public_path__ + "static/media/Hhand.4b6301d10ee83eb0c32560d03b0209a6.svg";
export { ForwardRef as ReactComponent };